module.exports = __webpack_public_path__ + "static/img/lotte-aa.7bcdffb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lotte-aa.jpg
// module id = BrmI
// module chunks = 0